module.exports = __webpack_public_path__ + "static/media/building.3424704e.jpg";